module.exports = __webpack_public_path__ + "img/third-slide-logo.d8373c8a.png";